// extracted by mini-css-extract-plugin
export default {"image":"BZ-z","loaded":"CZ-z"};